// extracted by mini-css-extract-plugin
export default {"container":"Error_container__cRMi1","descContainer":"Error_descContainer__epbUw","descripcion":"Error_descripcion__+OSJj","img":"Error_img__G1Eht","button":"Error_button__qK6Zt"};